import { useContext } from "react";
import { useLocStore } from "../../../localization";
import { LocContext } from "../../../localization/LocContext";
import { persistAndStopPropagation } from "../../../utils/util";
import {
  useShowVpnTools,
  AdminContext,
} from "../../adminSettings/AdminContext";

export function useVpnToolsMenuItem() {
  const L = useLocStore(LocContext.PROFILE);
  const showVpnTools = useShowVpnTools();
  const adminContext = useContext(AdminContext);

  return {
    label: L.id("943c110b3cde").loc("Vis VPN verktøy"),
    icon: showVpnTools ? "pi pi-fw pi-check-circle" : "pi pi-fw pi-circle",
    className: "vpn-item vpn-only",
    onClick: (evt) => {
      adminContext.setShowVpnTools(!showVpnTools);
      evt.preventDefault();
      persistAndStopPropagation(evt);
    },
  };
}
